import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WinLossArrayModel, WinLossModel } from "../../models/WinLossModel";

const initialState: WinLossArrayModel = {
  bidStatusHistory: [],
};
const WinLossSlice = createSlice({
  name: "WinLoss",
  initialState: initialState,
  reducers: {
    setBidStatusHistory(state, action: PayloadAction<WinLossModel[]>) {
      state.bidStatusHistory = action.payload;
    },
  },
});
export default WinLossSlice;
